// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import { LoadablePaint, LoadableLazy } from '@confluence/loadable';

import { ForgeContentToolsPlaceholder } from './ForgeContentToolsPlaceholder';
export { ForgeContentToolsPlaceholder };

export const ContentTools = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ContentTools" */ './ContentTools')).ContentTools,
});

export const ForgeContentTools = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ForgeContentTools" */ './ForgeContentTools'))
			.ForgeContentTools,

	loading: ForgeContentToolsPlaceholder,
});

export const LazyForgeContentTools = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ForgeContentTools" */ './ForgeContentTools'))
			.ForgeContentTools,
});
